import React from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Box,
  Typography,
  useTheme,
  Container,
  Grid,
  MenuItem,
  useMediaQuery,
  Select,
  FormControl,
  FormHelperText,
  TextField,
  TextareaAutosize,
  Divider,
} from "@material-ui/core";
import { useMutation, useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import VerificationCode from "./VerificationCode";
import { useAlert } from "../components/Alert";
import LoadingModal from "../components/LoadingModal";

const SAVE_CUSTOMER = gql`
  mutation saveCustomer($customerInput: CustomerInput!) {
    saveCustomer(customerInput: $customerInput)
  }
`;

const GET_PAGECONTENTS = gql`
  query pageContents {
    pageContents {
      id
      area
      imageUrl
    }
  }
`;

export default function WholeHousePage() {
  const theme = useTheme();
  const useStyles = makeStyles(() => ({
    gridbox: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      "& .MuiTypography-h4": {
        fontWeight: 700,
        marginBottom: "50px",
        color: theme.palette.secondary.light,
      },
    },
    img: {
      width: "356px",
      height: "356px",
    },
  }));
  const classes = useStyles();
  const Alert = useAlert();
  const { data } = useQuery(GET_PAGECONTENTS, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onError(error) {
      Alert.notice(`${error.message.replace("GraphQL error: ", "")}`);
    },
  });
  return (
    <Box
      style={{
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Container maxWidth="md">
        <Box>
          <Grid
            container
            style={{ paddingTop: "50px", marginBottom: "50px" }}
            spacing={1}
          >
            <Grid item xs={12} sm={6} className={classes.gridbox}>
              <Typography variant="h4">整屋前</Typography>
              <img
                src={data?.pageContents[0].imageUrl}
                alt=""
                className={classes.img}
              />
            </Grid>
            <Grid item xs={12} sm={6} className={classes.gridbox}>
              <Typography variant="h4">整屋後</Typography>
              <img
                src={data?.pageContents[1].imageUrl}
                alt=""
                className={classes.img}
              />
            </Grid>
          </Grid>
        </Box>
      </Container>
      <Divider
        variant="middle"
        style={{
          backgroundColor: theme.palette.secondary.light,
          height: "2px",
          width: "80%",
        }}
      />
      <WholeHouseForm />
    </Box>
  );
}

function WholeHouseForm() {
  const isTable = useMediaQuery("(max-width:960px)");
  const isPhone = useMediaQuery("(max-width:600px)");
  const useStyles = makeStyles((theme) => ({
    root: {
      "& .MuiListItem-root.Mui-selected:hover": {},
      "& .MuiSelect-selectMenu": {
        backgroundColor: "#fff",
      },
      "& .Mui-focused": {
        border: "none" + " !important",
        outline: "none" + " !important",
      },
    },
    formGrid: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      "& .MuiFormLabel-root": {
        // fontSize:'14px'+ ' !important',
      },
    },
  }));

  const classes = useStyles();
  const theme = useTheme();
  const { handleSubmit, control } = useForm({
    defaultValues: {
      fullName: "",
      lineId: "",
      mobile: "",
      budget: "",
      remark: "",
      vcode: "",
    },
  });

  const Alert = useAlert();
  const [saveCustomer, { loading: saveCustomerLoading }] = useMutation(
    SAVE_CUSTOMER,
    {
      onCompleted({ saveCustomer }) {
        if (saveCustomer) {
          window.location.reload();
          return Alert.notice("送出成功");
        }
      },
      onError(error) {
        return Alert.notice(`${error}`);
      },
    }
  );
  function _submit(data) {
    const customerInput = {
      customerType: "SERVICE_AREA",
      source: "NETWORK",
      assignStatus: "WAITING_TO_CONTACT",
      remark: `我要整屋=>整屋預算：${data.budget}${
        data.remark !== "" ? "，備註：" + data.remark : ""
      }`,
      customerInfo: [
        {
          fullName: data.fullName,
          mobile1: data.mobile,
          line: data.lineId,
        },
      ],
      frontSite: true,
    };

    saveCustomer({ variables: { customerInput } });
  }
  const [budgetValue, setBudgetValue] = React.useState("");

  return (
    <Container maxWidth="md" style={{ height: "100%" }}>
      <LoadingModal loading={saveCustomerLoading} />
      <Box py={4} className={classes.formGrid}>
        {/* form area */}
        <Grid container>
          {/* title */}
          <Grid xs={12} item>
            <Box>
              <Typography
                variant={isTable ? "h4" : "h2"}
                align="center"
                style={{
                  fontWeight: 700,
                  color: theme.palette.secondary.light,
                }}
              >
                我要整屋
              </Typography>
            </Box>
          </Grid>
          {/* title area end */}
          {/* form */}
          <Grid
            container
            xs={12}
            justify={isPhone ? "space-between" : "flex-start"}
            spacing={2}
          >
            {/* ANCHOR 姓名 */}
            <Grid item md={4} xs={6}>
              <Controller
                name="fullName"
                control={control}
                rules={{
                  required: "請輸入姓名",
                }}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography variant="body2" style={{ color: "#616161" }}>
                      姓名
                    </Typography>
                    <TextField
                      placeholder="姓名"
                      {...field}
                      error={error}
                      helperText={error && error.message}
                      fullWidth
                    />
                  </>
                )}
              />
            </Grid>
            {/* ANCHOR Line 帳號 */}
            <Grid item md={4} xs={6}>
              <Controller
                name="lineId"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography variant="body2" style={{ color: "#616161" }}>
                      Line帳號
                    </Typography>
                    <TextField
                      // label="Line帳號"
                      placeholder="Line帳號"
                      {...field}
                      fullWidth
                    />
                  </>
                )}
              />
            </Grid>
            {/* ANCHOR 電話 */}
            <Grid item md={4} xs={12}>
              <Controller
                name="mobile"
                control={control}
                rules={{
                  required: "請輸入電話",
                  pattern: {
                    // value: MobilePattern,
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography variant="body2" style={{ color: "#616161" }}>
                      電話
                    </Typography>
                    <TextField
                      placeholder="電話"
                      {...field}
                      error={error}
                      helperText={error && error.message}
                      fullWidth
                    />
                  </>
                )}
              />
            </Grid>
            {/* ANCHOR 整屋預算 */}
            <Grid item md={4} xs={6}>
              <Controller
                control={control}
                name="budget"
                rules={{
                  required: "整屋預算為必填選項",
                }}
                render={({
                  field: { onChange, ...otherField },
                  fieldState: { error },
                }) => (
                  <FormControl
                    size="small"
                    variant="outlined"
                    fullWidth
                    error={error}
                  >
                    <Typography variant="body2" style={{ color: "#616161" }}>
                      整屋預算
                    </Typography>
                    <Select
                      {...otherField}
                      value={budgetValue}
                      displayEmpty
                      onChange={(event) => {
                        setBudgetValue(event.target.value);
                        onChange(event);
                      }}
                      renderValue={
                        budgetValue === ""
                          ? () => (
                              <Typography style={{ color: "#9E9E9E" }}>
                                請選擇金額
                              </Typography>
                            )
                          : undefined
                      }
                    >
                      <MenuItem value="10萬以下">10萬以下</MenuItem>
                      <MenuItem value="10萬~50萬">10萬~50萬</MenuItem>
                      <MenuItem value="50萬~100萬">50萬~100萬</MenuItem>
                      <MenuItem value="100萬以上">100萬以上</MenuItem>
                    </Select>
                    <FormHelperText style={{ bottom: "-30%" }}>
                      {error && error.message}
                    </FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            {/* ANCHOR 備註 */}
            <Grid item xs={12}>
              <Controller
                name="remark"
                control={control}
                rules={{
                  required: false,
                }}
                render={({ field, fieldState: { error } }) => (
                  <FormControl
                    size="small"
                    variant="outlined"
                    error={error}
                    fullWidth
                  >
                    <Typography variant="body2" style={{ color: "#616161" }}>
                      備註
                    </Typography>
                    <TextareaAutosize
                      {...field}
                      error={error}
                      fullWidth
                      placeholder="備註"
                      style={{
                        resize: "none",
                        height: "120px",
                        fontSize: "1em",
                        padding: "10px",
                      }}
                    />
                    <FormHelperText style={{ bottom: "-30%" }}>
                      {error && error.message}
                    </FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            <Grid item md={5} xs={3}>
              <Controller
                name="vcode"
                control={control}
                rules={{
                  validate: (v) => {
                    if (v !== localStorage.getItem("@fullhouseVcode"))
                      return "驗證碼錯誤";
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography variant="body2">驗證碼</Typography>
                    <Grid container item spacing={1} direction="row">
                      <Grid item>
                        <TextField
                          {...field}
                          error={error}
                          helperText={error && error.message}
                          fullWidth
                          size="small"
                        />
                      </Grid>
                      <Grid item style={{ marginTop: "10px" }}>
                        <VerificationCode />
                      </Grid>
                    </Grid>
                  </>
                )}
              />
            </Grid>
          </Grid>
          {/* form area end */}
        </Grid>
        {/* button */}

        <Box display="flex" justifyContent="center">
          <Button
            variant="contained"
            onClick={handleSubmit(_submit)}
            fullWidth
            style={{
              color: "#fff",
              backgroundColor: theme.palette.secondary.light,
              borderRadius: "40px",
              height: "50px",
              marginTop: "40px",
              width: isTable ? "100%" : "30%",
            }}
          >
            送出
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
